(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.tmpLocationFilterFormHighlightStars = {
    getUrlsForStars: function (links) {
      $(links).each(function () {
        var url = $(this).find('a').attr('href');
        var areaValue = $(this).attr('data-area');
        var starLink = $('.tmp-by-location-filter-form__map-star-path[data-area ="' + areaValue + '"]').closest('.tmp-by-location-filter-form__map-star-link');
        $(starLink).attr('href', url);
      });
    },
    attach: function (context, settings) {
      $(once('highlight-stars', '.tmp-by-location-filter-city-list-form', context)).each(function () {
        Drupal.behaviors.tmpLocationFilterFormHighlightStars.getUrlsForStars($('.tmp-filter-options-wrapper__list-item[data-area]'));

        $('.tmp-filter-options-wrapper__list-item').mouseenter(function () {
          var area = $(this).data('area');
          $('.tmp-by-location-filter-form__map-star-path[data-area=' + area + ']').addClass('js-active');
        });

        $('.tmp-filter-options-wrapper__list-item').mouseleave(function () {
          var area = $(this).data('area');
          $('.tmp-by-location-filter-form__map-star-path[data-area=' + area + ']').removeClass('js-active');
        });

        $('.tmp-by-location-filter-form__map-star-path').mouseenter(function () {
          var area = $(this).data('area');
          $('.tmp-filter-options-wrapper__list-item[data-area=' + area + ']').find('a').addClass('js-active');
        });

        $('.tmp-by-location-filter-form__map-star-path').mouseleave(function () {
          var area = $(this).data('area');
          $('.tmp-filter-options-wrapper__list-item[data-area=' + area + ']').find('a').removeClass('js-active');
        });
      });
    }
  };

  Drupal.behaviors.tmpLocationFilterFormAutocomplete = {
    attach: function (context, settings) {
      $('#edit-select-city').on('change', function (e) {
        var str = e.target.value;
        var latLon = str.substring(
          str.lastIndexOf('(') + 1,
          str.lastIndexOf(')')
        );
        var textToDisplay = str.split(') ').pop();

        if (textToDisplay) {
          window.location.href = '/tennessee-music-pathways/all?selected-city=' + latLon;
        }
      });

      $(once('autocomplete', '.tmp-by-location-filter-city-search-form', context)).each(function () {
        $('input[data-drupal-selector=edit-search-by-city]').on('autocompleteclose', function (e) {
          var str = e.target.value;
          var latLon = str.substring(
            str.lastIndexOf('(') + 1,
            str.lastIndexOf(')')
          );
          var textToDisplay = str.split(') ').pop();

          if (textToDisplay) {
            $(this).val(textToDisplay);
            window.location.href = '/tennessee-music-pathways/all?selected-city=' + latLon;
          }
        });
      });
    }
  };



})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef



